import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosInstance } from "./auth/AxiosInstance";

export const useSendQuote = () => {
    return useMutation({
        mutationFn: async (data) => {
            const response = await AxiosInstance.post('/quotes', data);
            return response.data;
        }
    })
}

export const useGetQuotes = () => {
    return useQuery({
        queryKey: ['quotes'],
        queryFn: async () => {
            const response = await AxiosInstance.get('/quotes');
            return response.data;
        }
    })
}

export const useReplyToQuote = () => {
    return useMutation({
        mutationFn: async ({ quoteId, replyContent }) => {
            const response = await AxiosInstance.post(`/quotes/${quoteId}/reply`, { replyContent });
            return response.data;
        }
    })
}
